import { createContext, useContext, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Initialize auth state from session storage
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem("isAuthenticated") === "true";
  });

  const [loading] = useState(false);
  const [error, setError] = useState(null);

  const login = useCallback((username, password) => {
    // Fixed credentials check
    if (username === "guest" && password === "%@Dataforge2026#") {
      sessionStorage.setItem("isAuthenticated", "true");
      sessionStorage.setItem("username", username);
      setIsAuthenticated(true);
      setError(null);
      
      // Redirect to intended page or dashboard
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
      
      return { success: true };
    }
    setError("Invalid username or password");
    return { success: false, error: "Invalid username or password" };
  }, [navigate, location.state]);

  const logout = useCallback(() => {
    sessionStorage.removeItem("isAuthenticated");
    sessionStorage.removeItem("username");
    setIsAuthenticated(false);
    navigate("/login", { replace: true });
  }, [navigate]);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const value = {
    isAuthenticated,
    loading,
    error,
    login,
    logout,
    clearError,
    user: isAuthenticated ? { username: sessionStorage.getItem("username") || "guest" } : null,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export default AuthProvider;
